import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import {
    AngularLoginConfig,
    LoginData,
    ResponseStatusCodes,
    DialogsService,
    AngularAppConfig
} from 'angular-library';

import { UserService } from '../core/services/user.service';
import { userData, Dirette } from '../shared/shared.module';
import { environment } from '../../environments/environment';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

export class PortaleCalcio {
    nome: string;
    valore: string;
    selected: boolean;
}


@Component({
    moduleId: module.id,
    selector: 'login',
    templateUrl: 'angular-login.html'
    // ,template: '<angular-login [hidden]="queryParamsChecking" [loginConfig]="config"
    //  [listaPortali]="portali" (doLogin)="doLogin($event)"></angular-login><angular-alert></angular-alert>'
})
export class LoginComponent implements OnInit {
    portali: Array<PortaleCalcio> = [];
    config: AngularLoginConfig = new AngularLoginConfig();
    queryParamsChecking = true;
    loginInfo: FormGroup;
    comboValue: any;
    constructor(private fb: FormBuilder, private userService: UserService, private router: Router, private route: ActivatedRoute, private dialogsService: DialogsService) {
        this.config.logoImgUrl = 'img/logo.png';
        this.config.appName = environment.appFullName + '<br><small>Gestione delle Dirette</small>';
        this.loginInfo = fb.group({
            'userId': '',
            'password': '',
            'wp_db_prefix': new FormControl('', Validators.required)
        })
        this.userService.getListaPortali().then((c: any) => {
            for (const item of c.payload) {
                let p0: PortaleCalcio = new PortaleCalcio();
                p0.nome = item.portale;
                p0.valore = item.wp_db_prefix;
                p0.selected = false;
                this.portali.push(p0);
            }
        });
    }

    ngOnInit(): void {
        this.route.params.subscribe(
            (data: Params) => {
                if (data['token']) {
                    this.userService
                        .loginByToken(data['token'])
                        .then(loginResponse => {
                            if (loginResponse.status != ResponseStatusCodes.OK) {
                                this.config.waitAttivo = false;
                                this.dialogsService.alert('Autenticazione fallita', loginResponse.message);
                                this.queryParamsChecking = false;
                            } else {
                                this.router.navigate(['/index']);
                            }
                        });
                } else {
                    this.queryParamsChecking = false;
                }
            }

        );
    }

    doLogin(loginData: LoginData) {
        this.config.waitAttivo = true;
        this.config.messageAttivo = false;
        this.userService
            .login(loginData)
            .then(loginResponse => {
                if (loginResponse.status !== ResponseStatusCodes.OK) {
                    this.config.message = loginResponse.message;
                    this.config.waitAttivo = false;
                    this.config.messageAttivo = true;
                } else {
                    if (!userData.hasAdministration(AngularAppConfig.getUserData())) {
                        this.router.navigate(['/elenco-dirette']);
                    } else {
                        this.router.navigate(['/']);
                    }
                }
            });
    }

    onSubmit() {
        let loginData: LoginData = this.loginInfo.value;
        this.doLogin(loginData);
    }

}




// WEBPACK FOOTER //
// ./src/app/login/login.component.ts